<template>
  <div id="page">
    <van-sticky>
      <div class="search-box">
        <van-search v-model="search" placeholder="商品搜索" />
      </div>
    </van-sticky>
    <!-- 一级导航 -->
    <div class="nav-level1">
      <div
        class="nav-item-level1"
        v-for="(nav, index) in productData"
        :key="index"
        @click.stop="
          navActiveLevel1 = index
          navObjLevel1 = nav
        ">
        <img :src="nav.Img" loading="lazy" />
        <div :class="navActiveLevel1 === index ? 'selected' : ''">
          {{ nav.Title }}
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <van-row type="flex" style="height: 100%">
        <!-- 二级导航栏 -->
        <van-col span="5" class="navLevel2">
          <van-sidebar
            v-model="navActiveLevel2"
            v-if="navObjLevel1"
            style="width: 100%">
            <van-sidebar-item
              style="width: 100%; font-size: 13px"
              :title="nav.Title"
              v-for="(nav, index) in navObjLevel1.Items"
              :key="index" />
          </van-sidebar>
        </van-col>
        <!-- 商品列表 -->
        <van-col span="19" class="product-list">
          <product-item
            :visableShoppingCart="true"
            :model="item"
            v-for="(item, index) in filterProducts"
            :key="index"
            @countChange="countChange"
            :badge="
              shoppingCart
                .filter((v) => v.ProductId === item.Id)
                .map((v) => v.Count)
                .find((v) => v)
            "></product-item>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import productItemVue from './productItem.vue'

export default {
  name: 'product-list',
  components: {
    'product-item': productItemVue
  },
  props: {
    //商品数据
    productData: Array,
    shoppingCartData: {
      Type: Array,
      default: () => []
    }
  },
  data() {
    return {
      search: '',
      navObjLevel1: null,
      navActiveLevel1: null,
      navActiveLevel2: null,
      shoppingCart: this.shoppingCartData
    }
  },
  computed: {
    navSelectedItemLevel2() {
      if (
        this.navObjLevel1 &&
        this.navObjLevel1.Items &&
        this.navObjLevel1.Items.length > 0 &&
        this.navActiveLevel2 !== null
      ) {
        return this.navObjLevel1.Items[this.navActiveLevel2]
      }
      return []
    },

    filterProducts() {
      if (this.navSelectedItemLevel2 && this.navSelectedItemLevel2.Items) {
        return this.navSelectedItemLevel2.Items.filter(
          (v) => !this.search || v.Title.includes(this.search)
        )
      }
      return []
    }
  },
  methods: {
    countChange(product, count) {
      let index = this.shoppingCart.findIndex((v) => v.ProductId === product.Id)
      if (index >= 0) {
        let item = this.shoppingCart[index]

        if (count <= 0) {
          //数量为0就删掉
          this.shoppingCart.splice(index, 1)
        } else {
          //更新数量
          item.Count = count
        }
      } else if (count > 0) {
        //首次添加
        this.shoppingCart.push({
          ProductId: product.Id,
          Product: product,
          Count: count
        })
      }
    }
  },
  watch: {
    productData() {
      // 一级导航
      if (
        this.navActiveLevel1 === null &&
        this.productData &&
        this.productData.length > 0
      ) {
        this.navActiveLevel1 = 0
        this.navObjLevel1 = this.productData[this.navActiveLevel1]
      }
      //二级导航
      if (
        this.navActiveLevel2 === null &&
        this.navObjLevel1 &&
        this.navObjLevel1.Items.length > 0
      ) {
        this.navActiveLevel2 = 0
      }
    },
    navActiveLevel1() {
      this.navActiveLevel2 = 0
    }
  }
}
</script>

<style scoped>
#page {
  background-color: rgb(251, 251, 251);
}

.nav-level1 {
  font-size: 12px;
  height: 90px;
  overflow-x: scroll;
  white-space: nowrap;
  background-color: white;
}

.nav-level1 .selected {
  background-color: rgb(1, 102, 184);
  border-radius: 5px;
  padding: 2px 0;
  color: white;
}

.nav-item-level1 {
  width: 70px;
  height: 70px;
  padding: 5px 5px;
  display: inline-block;
  text-align: center;
}

.nav-item-level1 img {
  width: 60px;
  height: 60px;
  border-radius: 20px;
}

.nav-item-level1 span {
  background-color: aliceblue;
}

.content {
  margin-top: 10px;
  background-color: white;
  /* 搜索框55px 一级导航90px 内容间距10px 底部导航栏70px */
  height: calc(100vh - 55px - 90px - 10px - 70px);
  overflow-y: scroll;
}
.navLevel2 {
  height: 100%;
  overflow-y: scroll;
}
.search-box {
  height: 55px;
}
.product-list {
  height: 100%;
  overflow-y: scroll;
}
</style>
<style>
.van-sidebar-item--select::before {
  background-color: rgb(1, 102, 184) !important;
}
.van-sidebar-item--select .van-sidebar-item__text {
  font-weight: bold;
}
.van-search__content {
  border: 1px rgb(1, 102, 184) solid;
  border-radius: 5px !important;
}
.van-stepper--round .van-stepper__plus {
  background-color: #0166b8 !important;
}
.van-stepper--round .van-stepper__minus {
  border-color: #0166b8 !important;
  color: #0166b8 !important;
}
</style>
